module.exports = __webpack_public_path__ + "images/vibecode_logo_analytics.svg";


//////////////////
// WEBPACK FOOTER
// ./images/vibecode_logo_analytics.svg
// module id = 16
// module chunks = 1